import * as cleaningSupportCodes from '../../consts/iot/cleaningSupportCodes';
import iotDeviceConfig from './iotDeviceConfig';

const isDeviceResetEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_reset;

const isHolderLedModeEnabled = (iotDevice) => getFeaturesConfig(iotDevice).holder_led_intensity_mode;

const isDeviceLedModeEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_led_intensity_mode;

const isVibrationEnabled = (iotDevice) => {
    const _isHolderChargedVibrationEnabled = isHolderChargedVibrationEnabled(iotDevice);
    const _isExtendedHapticProfileVibrationEnabled = isExtendedHapticProfileVibrationEnabled(iotDevice);
    const _isProgrammableVibrationSettingsEnabled = isProgrammableVibrationSettingsEnabled(iotDevice);
    const _isStartVibrationEnabled = isStartVibrationEnabled(iotDevice);

    return (
        _isHolderChargedVibrationEnabled ||
        _isExtendedHapticProfileVibrationEnabled ||
        _isProgrammableVibrationSettingsEnabled ||
        _isStartVibrationEnabled
    );
};

const isCleaningEnabled = (iotDevice) => !!getFeaturesConfig(iotDevice).device_self_cleaning;

const isHolderChargedVibrationEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_holder_charged_vibration;

const isExtendedHapticProfileVibrationEnabled = (iotDevice) =>
    getFeaturesConfig(iotDevice).extended_haptic_profile_vibration;

const isStartVibrationEnabled = (iotDevice) => getFeaturesConfig(iotDevice).start_charging_vibration;

const isProgrammableVibrationSettingsEnabled = (iotDevice) =>
    getFeaturesConfig(iotDevice).programmable_vibrations?.setting_supported;

const isDeviceAlarmEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_alarm;

const MILLISECONDS_IN_SECOND = 1000;

const getDeviceAlarmDuration = (iotDevice) =>
    getFeaturesConfig(iotDevice).device_alarm_duration * MILLISECONDS_IN_SECOND;

const isChargingWhileCleaningNeeded = (iotDevice) => {
    return getFeaturesConfig(iotDevice).device_self_cleaning === cleaningSupportCodes.AVAILABLE_WHILE_CHARGING;
};

const isParentProtectionMode = (iotDevice) => getFeaturesConfig(iotDevice).device_parent_protection_mode;

const isConnectCareModeEnabled = (iotDevice) => getFeaturesConfig(iotDevice).connect_care_mode;

const isResponsiveDrawModeEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_responsive_draw_profile_mode;

const isVapeCloudModeEnabled = (iotDevice) => getFeaturesConfig(iotDevice).device_vape_cloud_size_mode;

const isAutoStartEnabled = (iotDevice) => getFeaturesConfig(iotDevice).autostart_feature;

const isGesturesStatus = (iotDevice) => getFeaturesConfig(iotDevice).status_gestures;

const isAdvancedDiagnostic = (iotDevice) => getFeaturesConfig(iotDevice).advanced_diagnostic;

const isCountDownMode = (iotDevice) => getFeaturesConfig(iotDevice).countdown_mode;

const isSessionProfilingEnabled = (iotDevice) => getFeaturesConfig(iotDevice).session_profiling;

const isIdlePingEnabled = () => getFeaturesConfig().idle_ping;

const getFeaturesConfig = (iotDevice) => {
    return iotDeviceConfig.getManagementFeaturesConfig(iotDevice);
};

export default {
    isCountDownMode,
    isGesturesStatus,
    isAutoStartEnabled,
    getDeviceAlarmDuration,
    isChargingWhileCleaningNeeded,
    isCleaningEnabled,
    isDeviceAlarmEnabled,
    isDeviceLedModeEnabled,
    isDeviceResetEnabled,
    isConnectCareModeEnabled,
    isExtendedHapticProfileVibrationEnabled,
    isStartVibrationEnabled,
    isHolderChargedVibrationEnabled,
    isHolderLedModeEnabled,
    isParentProtectionMode,
    isProgrammableVibrationSettingsEnabled,
    isResponsiveDrawModeEnabled,
    isVapeCloudModeEnabled,
    isVibrationEnabled,
    isSessionProfilingEnabled,
    isAdvancedDiagnostic,
    isIdlePingEnabled,
};
